<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

let type = "TRUCK_TRAILER";

export default {
    methods:{
        init: (payload) => {
            
            const el = document.body;
            el.removeAttribute("class");

            payload.domain = Endpoints.domain;

            setTimeout(async function(){
                let query = {
                    type: type
                };

                let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
                if (response.status==200){
                    let responseManu = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), query, `${Endpoints.parts.manufacturer.listByType}`)).data;
                    payload.manufacturers = responseManu.results;

                    let responseCertifies = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.parts.certifies.list}`);
                    payload.certifies = responseCertifies.data.results;

                    let responsetruckTrailerTypes = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.helpers.listTruckTrailer}`);
                    payload.truckTrailerTypes = responsetruckTrailerTypes.data.results;

                    let responseSpeciesTypes = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.helpers.listSpeciesTypes}`);
                    payload.speciesTypes = responseSpeciesTypes.data.results;

                    let trucker = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),{status:'ACTIVE'}, `${Endpoints.systemUsers.filter}`));
                    if (trucker.status==200){
                        payload.truckers = trucker.data.results; 
                    }

                    let companies = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), payload.filtersCompany, `${Endpoints.companies.filter}`));
                    if (companies.status==200){
                        payload.companies = companies.data.results;
                    }

                }
            }, 100);

            if(payload.truckTraillerId){
                payload.getTruckTrailler(payload.truckTraillerId); 
            }

        },
        getTruckTrailler: function(id){
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            
            $('#spinner').modal('toggle');
            Request.do(this, 'GET', Request.getDefaultHeader(this), null, `${Endpoints.trucks.truck}${id}`,
            (response)=>{//SUCCESS CALLBACK
                this.data = response.result;
                $('#spinner').modal('toggle');
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        customLabelCompany(option) {
            return `${this.toUpperCase(option.fantasyName)}`
        },
        
        listCompanies: function(){
            this.companies = [];
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.filtersCompany, `${Endpoints.companies.filter}`,
            (response)=>{//SUCCESS CALLBACK
                this.companies = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        save: async function(){
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            let data = JSON.parse(JSON.stringify(this.data));

            if(data.company && data.company._id){
                data.company = data.company._id;
            }

            if(data.truckDriver && data.truckDriver._id){
                data.truckDriver = data.truckDriver._id;
            }

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('jsonData', JSON.stringify(data));

            Request.do(this, this.data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), formData, `${Endpoints.trucks.truckFormData}${this.data._id ? this.data._id : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    
                    if (!this.data._id){
                        this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.truck.trailer.register.title.success'), this.$t('string.msg.truck.trailer.register.message.success'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.truck.trailer.register.message.success')),
                            destroyed: this.clearText()
                        })
                    } else{
                        this.flashMessage.info(
                            this.configMessage(this.$t('string.msg.truck.trailer.register.title.alter'), this.$t('string.msg.truck.trailer.register.message.alter'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.truck.trailer.register.message.alter')),
                            destroyed: this.clearText()
                        })
                    }
                },
                (error)=>{//ERROR CALLBACK
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }
                        $('#toast').modal('show');
                    }
            });
        },
        selectItem: function(item){
            this.clearForm();

            this.data = JSON.parse(JSON.stringify(item));
       
            let manufacturer = null;
            if(this.data.manufacturer){
                 manufacturer =  this.data.manufacturer
                this.onChange(manufacturer)
            }
            
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                
                Request.do(this, 'DELETE', Request.getDefaultHeader(this), this.data, `${Endpoints.trucks.truck}${this.data._id}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');

                        this.$eventHub.$emit('refreshList');

                        this.flashMessage.warning(
                            this.configMessage(this.$t('string.msg.truck.trailer.register.title.filed'), this.$t('string.msg.truck.trailer.register.message.filed'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.truck.trailer.register.message.filed')),
                            destroyed: this.clearText()
                        })
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
        },
         confirmArchive: function(item){
               if (this.data.specie) {
                this.titleToast = this.$t("string.msg.confirm");
                this.messageToast = this.$t("response.archive.trucktrailer.confirmation");
                this.cancelText = this.$t("string.msg.cancel");
                this.yesText = this.$t("string.msg.yes");
                $('#confirmationModal').modal('show');
            }else{
                this.errors = [];
                this.errors.push(this.$t('response.truck.register.model.required.for.archive'));
            }
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        clearForm: function(){
            this.data = {},
            this.data.manufacturer = {},
            this.data.systemUsers = {},
            this.data.certifies = {},
            this.certifie = null;
            this.errors = [];
            this.expiredDate = null,
            this.shippingDate = null
        },
         add: function (e) {

            let state = this;

            if(state.shippingDate){
                let day,month,year;
                day = (state.shippingDate.slice(0,2));
                month = (state.shippingDate.slice(3,5));
                year = (state.shippingDate.slice(6,10));

                state.shippingDate = new Date();
                state.shippingDate.setDate(day);
                state.shippingDate.setMonth(month-1);
                state.shippingDate.setFullYear(year);
            }
            
            if(state.expiredDate){
                let day,month,year;
                day = (state.expiredDate.slice(0,2));
                month = (state.expiredDate.slice(3,5));
                year = (state.expiredDate.slice(6,10));

                state.expiredDate = new Date();
                state.expiredDate.setDate(day);
                state.expiredDate.setMonth(month-1);
                state.expiredDate.setFullYear(year);
            }  


            let cert = {
                certified:{
                    _id: state.certifie._id,
                    name: state.certifie.name,
                },
                shippingDate: state.shippingDate,
                expiredDate: state.expiredDate,
                photoURL: state.certifiePhotoURL
            }
            state.data.certifies.push(JSON.parse(JSON.stringify(cert)));

        },
        checkTable: function(){
            this.errors = [];
            if (!this.expiredDate) {
                this.errors.push(this.$t('response.truck.register.manufacturer.required'));
            }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.add();
            }
        },
        remove: function(_idCertified){
            let indexCert = this.data.certifies.findIndex(x => x.certified._id == _idCertified);
            if (indexCert > -1){
               this.data.certifies.splice(indexCert, 1);
            }
        },
         
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.manufacturer) {
                this.errors.push(this.$t('response.truck.register.manufacturer.required'));
            }

            if (!this.data.plate) {
                this.errors.push(this.$t('response.truck.register.plate.required'));
            }

             if (!this.data.specie) {
                 this.errors.push(this.$t('response.truck.register.groupType.required'));
             }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.save();
            }
        },
        showPhoto: function(url){
            this.photoURL = url;
             $('#modalPhoto').modal('show');
        },

        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        onChange: function(id){
            this.models = [];
            this.data.model = null;
            Request.do(this, 'POST', Request.getDefaultHeader(this), {manufacturer:id}, `${Endpoints.models.listByManufacturer}`,
            (response)=>{//SUCCESS CALLBACK
                this.models = response.results;   

                let index = this.models.findIndex(x => x.name == 'Outros');
                let others = null;
                if(index > -1){
                    others = this.models[index];
                    this.models.splice(index, 1);
                    this.models.push(others);
                }
            },
            (error)=>{//ERROR CALLBACK
                this.titleToast = this.$t('str.msg.toast.advice');
                this.messageToast = this.$t('str.msg.error.generic');
                let res = error.response;
                if (res){
                    this.messageIdToast = res;
                }
                $('#toast').modal('show');
                console.log(error);
            });
        },
        customLabel (option) {
            return `${option.firstName} ${option.lastName} - CPF: ${option.customerUser.document}`
        },

         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
